var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * 用户电话号码组件
 */
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { message } from 'antd';
import { debounce } from 'lodash';
import { IconCopyBtn } from '../IconFont';
// import IconCopyBtn from '../images/app_btn_copy.png';
function UserMobile(props) {
    var _this = this;
    var user = props.user, isSelf = props.isSelf, analysisLog = props.analysisLog, cardType = props.cardType, currUser = props.currUser, examineMobileRecord = props.examineMobileRecord, webExamineMobileRecord = props.webExamineMobileRecord;
    // const { t } = useTranslation('addressList');
    var _a = useState(false), isShow = _a[0], setDisplayState = _a[1];
    var mobileRef = useRef(null);
    var mobileData = user.fields.find(function (item) { return item.key === 'mobile'; });
    if (!mobileData) {
        return null;
    }
    var useMobile = function (isShow, mobileData) {
        var mobile = isShow || isSelf
            ? mobileData.val
            : mobileData.val.substring(0, 3) + '****' + mobileData.val.substring(7);
        return [mobile];
    };
    var Mobile = function (props) {
        var mobile = useMobile(props.isShow, props.mobileData)[0];
        return (React.createElement("span", { className: "usercard-item-desc mobile-desc", ref: mobileRef }, mobile));
    };
    var CheckFullNumber = function (props) {
        var _a = useState(false), isSending = _a[0], setIsSending = _a[1];
        var isMounted = useRef(true);
        useEffect(function () {
            return function () {
                isMounted.current = false;
            };
        }, []);
        var getExamineMobileRecord = function () { return __awaiter(_this, void 0, void 0, function () {
            var clickerName, examinedName;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(cardType === 'web')) return [3 /*break*/, 2];
                        return [4 /*yield*/, webExamineMobileRecord({
                                openUserId: user.userId,
                                openTeamId: user.teamId
                            })];
                    case 1: return [2 /*return*/, _c.sent()];
                    case 2:
                        clickerName = currUser === null || currUser === void 0 ? void 0 : currUser.name;
                        examinedName = ((_b = (_a = user) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.key === 'name'; }).val) || '';
                        return [4 /*yield*/, examineMobileRecord({
                                clickerUserId: currUser.userId,
                                clickerName: clickerName,
                                clickerTeamId: currUser.teamId,
                                // clickerSex,
                                examinedUserId: user.userId,
                                examinedName: examinedName,
                                examinedTeamId: user.teamId,
                                // examinedSex,
                                appId: user.appId
                            })];
                    case 3: 
                    // const examinedSex =
                    //     (user as any)?.fields?.find((item: UserCardItem) => item.key === 'sex').val || '';
                    return [2 /*return*/, _c.sent()];
                }
            });
        }); };
        var checkPermission = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, result, err;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (isSending)
                            return [2 /*return*/];
                        if (analysisLog)
                            analysisLog('xtbg_add_home_1637657110163', '24');
                        setIsSending(true);
                        return [4 /*yield*/, getExamineMobileRecord()];
                    case 1:
                        _a = _b.sent(), result = _a[0], err = _a[1];
                        setIsSending(false);
                        if (err) {
                            message.error(err);
                            return [2 /*return*/];
                        }
                        if (result === true) {
                            setDisplayState(true);
                        }
                        else if (result === false) {
                            message.info('您当天的查询次数已满');
                        }
                        return [2 /*return*/];
                }
            });
        }); }, [isSending]);
        return (React.createElement("div", { onClick: checkPermission, className: "user-mobile-copy-button" }, "\u67E5\u770B"));
    };
    function copyMobileNumber() {
        var _a;
        var copyValue = (_a = mobileRef.current) === null || _a === void 0 ? void 0 : _a.innerHTML;
        document.body.insertAdjacentHTML('beforeend', "<input style=\"height:0;widht:0\" id=\"temp-copy\" value=\"" + copyValue + "\">");
        var copyText = document.getElementById('temp-copy');
        copyText === null || copyText === void 0 ? void 0 : copyText.select();
        document.execCommand('Copy');
        copyText === null || copyText === void 0 ? void 0 : copyText.remove();
        setTimeout(function () {
            message.destroy();
            message.success('手机号已复制');
        }, 0);
    }
    return (React.createElement("div", { className: "usercard-item-content" },
        React.createElement("h5", { className: "usercard-item-title", style: { flex: 'none', lineHeight: '22px' } }, mobileData.name),
        React.createElement(Mobile, { isShow: isShow, mobileData: mobileData }),
        isShow || isSelf ? (React.createElement("div", { className: "user-mobile-copy-button", onClick: debounce(function () {
                if (analysisLog)
                    analysisLog('xtbg_add_home_1637657110163', '44');
                copyMobileNumber();
            }, 200) }, IconCopyBtn)) : (React.createElement(CheckFullNumber, null))));
}
export default UserMobile;
//# sourceMappingURL=Mobile.js.map